import { useMemo } from "react";
import { usePermissions, ROLES } from "../../../context/PermissionsContext/PermissionsContext";

/**
 * Hook para determinar qué dashboard mostrar según el rol del usuario
 *
 * Mapeo de roles a dashboards:
 * - CEO -> "ceo" (Executive Dashboard)
 * - Admin -> "admin" (System Administration)
 * - Care Management -> "care_manager" (Care Management Dashboard)
 * - Behavioral Health -> "behavioral_health" (BH Dashboard)
 * - PCP / default -> "pcp" (Clinical Dashboard)
 */
export default function useDashboardRouter() {
  const { userRole } = usePermissions();

  const dashboardType = useMemo(() => {
    switch (userRole) {
      case ROLES.CEO:
        return "ceo";
      case ROLES.ADMIN:
        return "admin";
      case ROLES.CARE_MANAGEMENT:
        return "care_manager";
      case ROLES.BEHAVIORAL_HEALTH:
        return "behavioral_health";
      case ROLES.PCP:
      default:
        return "pcp";
    }
  }, [userRole]);

  const dashboardTitle = useMemo(() => {
    switch (dashboardType) {
      case "ceo":
        return "Executive Dashboard";
      case "admin":
        return "System Administration";
      case "care_manager":
        return "Care Management Dashboard";
      case "behavioral_health":
        return "Behavioral Health Dashboard";
      case "pcp":
      default:
        return "Clinical Dashboard";
    }
  }, [dashboardType]);

  return {
    dashboardType,
    dashboardTitle,
    userRole,
  };
}
